import React from 'react'
import { LuChevronsUpDown, LuChevronUp, LuChevronDown } from 'react-icons/lu'


const SortableTableHeader = ({
  label,
  field,
  currentSortField,
  currentSortOrder,
  onSort,
  sortable = true,
}) => {
  const isActive = currentSortField === field
  const isAsc = isActive && currentSortOrder === 'asc'
  const isDesc = isActive && currentSortOrder === 'desc'

  const handleClick = () => {
    if (!sortable || !onSort) return

    let newOrder = ''
    if (!isActive || currentSortOrder === '') {
      newOrder = 'asc'
    } else if (currentSortOrder === 'asc') {
      newOrder = 'desc'
    } else {
      newOrder = ''
    }

    onSort(newOrder ? field : '', newOrder)
  }

  if (!sortable) {
    return (
      <th className="pl-5 py-4 font-semibold text-sm uppercase">
        {label}
      </th>
    )
  }

  const SortIcon = isAsc ? LuChevronUp : isDesc ? LuChevronDown : LuChevronsUpDown

  return (
    <th
      className="pl-5 py-4 cursor-pointer select-none hover:bg-[var(--color-gray-150)] transition-colors uppercase font-semibold text-sm"
      onClick={handleClick}
    >
      <div className="flex items-center gap-1.5">
        <span>{label}</span>
        <SortIcon
          size={16}
          className="shrink-0"
          style={{ color: isActive ? 'var(--color-primary-main)' : 'var(--color-gray-400)' }}
        />
      </div>
    </th>
  )
}

export default SortableTableHeader
